import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function SuperBonusesSection() {
  const superBonuses = [{
    number: 5,
    title: 'Módulo de Entrenamiento Cognitivo Adolescente (12 a 18 años)',
    subtitle: 'Porque los problemas de memoria y atención no empiezan a los 60',
    description: '50 fichas de estimulación cognitiva para adolescentes. Atención · Memoria · Funciones ejecutivas · Velocidad de procesamiento · Organización. Para el profesional que también atiende pacientes jóvenes con dificultades de concentración, bajo rendimiento escolar o perfiles de TDAH.',
    image: 'https://cdn.magicpatterns.com/uploads/gScCL1y4aqinVKb7SSN6Mf/e568b953-003a-4f8f-be90-34aad782e494-removebg-preview.png'
  }, {
    number: 6,
    title: 'Módulo de Agilidad Mental para Adultos (20 a 50 años)',
    subtitle: 'Para el paciente de mediana edad que tiene la mente llena de ruido',
    description: '50 fichas para adultos con sobrecarga cognitiva, estrés crónico, dificultades de foco o simplemente interesados en el rendimiento mental. El módulo más versátil del sistema para diversificar el perfil de pacientes del consultorio.',
    image: 'https://cdn.magicpatterns.com/uploads/2SXQTHjgsC4GJwrG7qBiNW/ChatGPT_Image_7_may_2026__09_36_28_p.m.-removebg-preview.png'
  }];
  return <section className="py-16 sm:py-24 bg-gradient-to-b from-amber-50 to-orange-50" data-id="element-229">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-231">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4" data-id="element-232">
            🚀 LOS 2 SÚPER BONOS MULTI-EDAD
          </h3>

          <p className="text-lg text-gray-700 mb-8" data-id="element-233">
            Para el profesional que quiere equipar su consultorio para todas las
            edades
          </p>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-234">
            {superBonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} whileHover={{
            y: -5
          }} className="bg-white p-6 rounded-lg shadow-lg border-2 border-amber-300 hover:shadow-xl transition-all duration-300" data-id="element-235">
                {bonus.image && <div className="flex justify-center mb-4 -mt-2" data-id="element-236">
                    <img src={bonus.image} alt={`Súper Bono ${bonus.number} - ${bonus.title}`} className="w-full max-w-[260px] drop-shadow-xl hover:scale-105 transition-transform duration-300" data-id="element-237" />
                  </div>}
                <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg px-4 py-2 inline-block mb-4 font-bold" data-id="element-238">
                  SÚPER BONO {bonus.number}
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-239">
                  {bonus.title}
                </h4>
                <p className="text-amber-700 font-semibold mb-3 italic" data-id="element-240">
                  {bonus.subtitle}
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-241">
                  {bonus.description}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}